// extracted by mini-css-extract-plugin
export default {"r_l":"d528282600 _2819a4be01","t":"b00ec644b2"};